import React, {useEffect, useState} from "react";
import {GameMode} from "../../../models/GameMode";
import {useParams, useNavigate} from "react-router";
import {CardChooseGameMode} from "./cardChooseGameMode";
import {GameApi} from "../../../services/api/GameApi";
import {useTranslation} from "react-i18next";



export const ChooseGameMode: React.FC = () => {
    const [gameMode, setGameMode] = useState<GameMode[]>([]);
    const { idGameTheme } = useParams();
    const navigate = useNavigate();
    const {t} = useTranslation();

    useEffect(() => {
        if (idGameTheme === undefined) return;

        GameApi.getGameModeFromTheme(parseInt(idGameTheme)).then((data) => {
            setGameMode(data);
        });
    }, [idGameTheme]);

    useEffect(() => {
        if (gameMode.length === 1) {
            navigate(`/${gameMode[0].name}`, { state: { gameModeId: gameMode[0].id } });
        }
    }, [gameMode, navigate]);

    return (
        <div className="px-12 md:px-28 xl:px-44 pt-20 pb-12 md:pt-28 xl:pt-30 flex flex-col h-full md:justify-center gap-8">
            <h1 className="text-4xl text-center">{t("game.choose-gamemode")}</h1>

            <div className="flex flex-col w-full md:flex-row md:justify-center flex-wrap gap-8">
                {gameMode.length === 0 ? <h1 className="text-xl text-center">{t("game.no-gamemode-available")}</h1> :
                    gameMode.map((element) => {
                        return (
                            <CardChooseGameMode key={element.id} gameMode={element} />
                        )
                    })
                }
            </div>
        </div>
    );
}
